/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type HexPermissionSummaryFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly publicRoleV2: Types.ProjectRole | null;
  readonly organizationRoleV2: Types.ProjectRole | null;
  readonly grantSummary: c.ProjectGrantSummary;
  readonly onlyGrantedToCurrentUser: boolean;
  readonly org: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly displayName: string;
    readonly allowPublicSharing: boolean;
    readonly resolvedAllowPublicSharing: boolean;
  };
};

export const HexPermissionSummaryFragmentDoc = /*#__PURE__*/ gql`
  fragment HexPermissionSummaryFragment on Hex {
    id
    publicRoleV2
    organizationRoleV2
    grantSummary
    onlyGrantedToCurrentUser
    org {
      id
      displayName
      allowPublicSharing
      resolvedAllowPublicSharing
    }
  }
`;
